/**
 * 
 * This script checks if cart is eligible for checkout
 * 
 * Cart is eligible for checkout if ...
 *  - Cart has $0 of frozen items 
 *  - Total of frozen items is >= $65
 *  - He might add a total amount that will override this
 * 
 * Gameplan
 *  - check math for items when the following callbacks are called
 *  - window.SLIDECART_LOADED
 *  - window.SLIDECART_UPDATED
 * 
 *  AMP slide cart docs: https://slide-cart.helpscoutdocs.com/article/87-slide-cart-callbacks-and-methods
 * 
 */


/**
 * Logic to run when cart is loaded
 */
window.SLIDECART_LOADED = function(cart) {
    //console.log("Cart Loaded");
    showCheckout(cart.items);
};


/**
 * Logic to run when cart is updated
 */
window.SLIDECART_UPDATED = function(cart) {
    //console.log("Cart Updated");
    showCheckout(cart.items);
};





/**
 * Hides or shows checkout details based on price
 */
function showCheckout(items) {
    if(cartEligible(items)) {
        $('.footer-sticky').show();
        $('.upcart-announcement').hide();
    }
    else {
        $('.footer-sticky').hide();
        $('.upcart-announcement').show();
    }
}



/**
 * Checks if cart is eligible for checkout
 * Returns true or false
 */
function cartEligible(items) {
    if (
        calculateFrozenPrice(items) ==    0 || 
        calculateFrozenPrice(items) >= 6500 
        ) 
    {
        return true;
    }
    else 
    {
        return false;
    }
}




/**
 * Calculate frozen price
 * Returns float for price
 */
function calculateFrozenPrice(items) {
    var frozenPrice = 0;
    items.forEach(item => {
        if (item.properties.Frozen === "true") {
            frozenPrice += item.original_line_price;
        }
    })
    return frozenPrice;
}




/**
 * Caulculate total price
 * Returns float for price
 * 
 * Currently isn't used, haven't decided on total minimum yet
 */
function calculateTotalPrice(items) {
    var totalPrice = 0;
    items.forEach(item => {
        totalPrice += item.original_line_price;
    })
    return totalPrice;
}